export default function (state = false, action) {
  switch (action.type) {
    case "IS_UPDATED":
      return action.payload;
      break;
    default:
      return state;
  }
}
